import Currency from "./Currency";
import ArticleStatus from "./ArticleStatus";

class Article {
    public id: string;
    public name: string;
    public sku: string;
    public description: string;
    public categoryId?: string;
    public categoryName?: string;
    public defaultImage: string;
    public confectionPrice: number;
    public confectionPriceCurrency: Currency;
    public createdAt: number;
    public physicalAmount: number;
    public bookAmount: number;
    public price: number;
    public purchasePrice: number;
    public status: ArticleStatus;

    constructor(
        id: string,
        name: string,
        sku: string,
        description: string,
        categoryId: string,
        categoryName: string,
        defaultImage: string,
        confectionPrice: number,
        confectionPriceCurrency: Currency,
        createdAt: number,
        physicalAmount: number,
        bookAmount: number,
        price: number,
        purchasePrice: number,
        status: ArticleStatus
    ) {
        this.id = id;
        this.name = name;
        this.sku = sku;
        this.description = description;
        this.categoryId = categoryId;
        this.categoryName = categoryName;
        this.defaultImage = defaultImage;
        this.confectionPrice = confectionPrice;
        this.confectionPriceCurrency = confectionPriceCurrency;
        this.createdAt = createdAt;
        this.physicalAmount = physicalAmount;
        this.bookAmount = bookAmount;
        this.price = price;
        this.purchasePrice = purchasePrice;
        this.status = status;
    }

}

export default Article;